import "./App.scss";
import HomePage from "./components/pages/HomePage/HomePage";
import CookieBanner from "./components/molecules/CookieBanner/CookieBanner";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const App = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ""}
    >
      <HomePage />
      <CookieBanner />
    </GoogleReCaptchaProvider>
  );
};

export default App;
